import { useTranslation } from 'react-i18next'

import { defaultCompanyDetailsValues } from 'adminDashboard/companySettings/companyDetails/CompanyDetailsView'

import { GetSeatCountStatisticsResponse, ProductIds, getForCompleteCompanyDetails } from 'core'

import { Button, Card, Col, Icon, Row, Skeleton, Tooltip } from 'common/components'
import { parseZoneFormat } from 'common/dateFormatters'
import { useLoginUserV2, useQueryRequestV2 } from 'common/hooks'

import './seatStatistic.less'

type PerksSeatStatisticProps = GetSeatCountStatisticsResponse & {
  planPeriodId: string
  loading: boolean
  toggleEditSeatModal: () => any
}

const SeatStatistic = ({ planPeriodId, ...props }: PerksSeatStatisticProps) => {
  const { t: translate } = useTranslation()
  const { user } = useLoginUserV2()

  const { data: companyDetails, isLoading: detailsQueryIsLoading } = useQueryRequestV2({
    initialState: defaultCompanyDetailsValues,
    queryFn: () => getForCompleteCompanyDetails(),
  })

  return (
    <Skeleton loading={detailsQueryIsLoading}>
      <Card className="mb-16" title={<h5 className="mb-0">{companyDetails?.name ?? ''}</h5>}>
        <div className="seats-statistic-container">
          <Row>
            <Col xs={24} sm={24} md={24} lg={12} xl={12} className="mb-16">
              <div className="seats-statistic__item">
                <div className="seats-statistic__item-header">
                  <div>
                    <span className="gray-7 mr-8 mb-0">
                      {translate('admin-dashboard.manage-people.seats-subscription-label')}
                    </span>
                    {user.productId === ProductIds.IchraId && (
                      <Tooltip
                        title={''}
                        overlay={
                          <>
                            This is the total number of ICHRA Seats for which you are currently paying. This number
                            includes your ineligible admin users and may be more than the total number of employees you
                            added to the benefit. You can reduce this number now by clicking the Edit Seats button. You
                            cannot reduce your Seat count below the number of opted-in employees plus the number of
                            admin users o the account. This number will automatically update each new billing cycle.
                          </>
                        }
                      >
                        <Icon className="fal fa-info-circle blue-6" />
                      </Tooltip>
                    )}
                  </div>
                  <Button type="primary" onClick={props.toggleEditSeatModal}>
                    {translate('admin-dashboard.manage-people.edit-seats-button-label')}
                  </Button>
                </div>

                <div className="seats-statistic__item-body">
                  <Skeleton loading={props.loading}>
                    <h5 className="mb-0 t-seats-total-seat-count">{props?.totalSeatCount}</h5>
                    {props?.nextSeat && (
                      <p className={'mt-32 next-seat-text t-seats-next-seat'}>
                        Changing to {props.nextSeat.seatNumber} seats as of {parseZoneFormat(props.nextSeat.startDate)}.
                      </p>
                    )}
                  </Skeleton>
                </div>
              </div>
            </Col>
            <Col xs={24} sm={24} md={24} lg={12} xl={12} className="mb-16">
              <div className="seats-statistic__item">
                <div className="seats-statistic__item-header">
                  <div>
                    <span className="gray-7 mr-8 mb-0">
                      {translate('admin-dashboard.manage-people.seats-used-label')}
                    </span>
                    {/* <Tooltip overlay={<span>{translate("admin-dashboard.manage-people.seats-used-tooltip")}</span>}>
                  <global.components.general.Icon className="fal fa-info-circle blue-6" />
                </Tooltip> */}
                  </div>
                </div>
                <div className="seats-statistic__item-body">
                  <Skeleton loading={props.loading}>
                    <h5 className="mb-0 t-seats-occupied-seats">{props?.occupiedSeats}</h5>
                    {props?.nextSeat && <p className={'mt-32 next-seat-text'}>&nbsp;</p>}
                  </Skeleton>
                </div>
              </div>
            </Col>
          </Row>
          {/*<p*/}
          {/*  className="seats-statistic__info-text mb-0"*/}
          {/*  dangerouslySetInnerHTML={{*/}
          {/*    __html: translate("admin-dashboard.manage-people.seats-note-label"),*/}
          {/*  }}></p>*/}
        </div>
      </Card>
    </Skeleton>
  )
}

export default SeatStatistic
